// extracted by mini-css-extract-plugin
export default {"settings-btn":"styles_settings-btn__xe8I3"};